var map = {
	"./custom/app/footer/footer.component": [
		79407,
		"src_themes_custom_app_footer_footer_component_ts"
	],
	"./dspace/app/footer/footer.component": [
		26758
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 43562;
module.exports = webpackAsyncContext;